import { defineNuxtPlugin } from '#app';
import { type Directive } from 'vue';
import vOutsideClick from '~/directives/v-outside-click';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('outside-click', vOutsideClick as Directive);
});
